exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".word-input {\n  max-width: 300px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/shared-module/widgets/word-list-input/word-list-input.component.scss
// module id = ../../../../../src/app/shared-module/widgets/word-list-input/word-list-input.component.scss
// module chunks = main